import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';

const Logo = ({ type }) => (
  <LogoWrapper
    type={type}
    role="img"
    aria-label={type === 'logo' ? 'Chroniker Logo' : 'Loading...'}
  >
    <Circle
      type={type}
    >
      <Hourglass
        type={type}
      />
    </Circle>
  </LogoWrapper>
);

const borderWidth = css`
${(props) => ((props.type === 'spinner') ? '32px' : '13px')}
`;
const logoBackground = css`
 ${(props) => props.theme.colors.gableGreen}
`;
const hourglassTop = css`
 ${(props) => props.theme.colors.sunGlow}
`;
const hourglassBottom = css`
 ${(props) => props.theme.main.iconDefault}
`;
const hourglassLeft = css`
 ${(props) => props.theme.colors.grenadier}
`;
const hourglassRight = css`
 ${logoBackground}
`;

const flip = (props) => keyframes`
  from {
    border-color: white blue yellow gray;
    //border-color: ${props.theme.colors.sunGlow} ${props.theme.colors.gableGreen} ${props.theme.main.iconDefault} ${props.theme.colors.grenadier};
  }
  to {
    border-color:  blue yellow gray white;
    //border-color: ${props.theme.main.iconDefault} ${props.theme.colors.gableGreen} ${props.theme.colors.sunGlow}  ${props.theme.colors.grenadier};
  }
`;

const LogoWrapper = styled.div`
  margin-left: 41px;
  @media screen and (max-width: ${(props) => props.theme.media.sm}){
    margin-left: unset;
   }
   ${(props) => props.type === 'spinner' && css`
    display: flex;
    width: 100%;
    height: 100%;
    margin-left: unset;
    align-content: center;
    justify-content: center;
`}
`;

const Hourglass = styled.div`
  border-style: solid;
  border-color: ${hourglassTop} ${hourglassRight} ${hourglassBottom} ${hourglassLeft};
  border-width: ${borderWidth} ${borderWidth} ${borderWidth} ${borderWidth};
  transition: 0.3s;
  ${(props) => props.type === 'spinner' && css`
  animation: ${flip} 0.5s alternate linear infinite;
`}
`;

const Circle = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: ${logoBackground};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  &:hover ${Hourglass} {
    border-color: ${hourglassBottom} ${hourglassRight} ${hourglassTop} ${hourglassLeft};
  }
  
  ${(props) => props.type === 'spinner' && css`
  width: 100px;
  height: 100px;
`}
`;

Logo.propTypes = {
  type: PropTypes.oneOf(['logo', 'spinner']).isRequired,
};

export default memo(Logo);
